/* support-menu-slideout — native popover=auto, right-side slideout. The host IS the popover
   (top layer + light-dismiss) and paints nothing; the Interstate slide-out DIY recipe
   (.ids-slideout / .ids-slideout-right, applied to the inner .support-menu-slideout-surface)
   drives the full surface — background, shadow, padding, flex, gap, position, height,
   overflow. Only the surface width (the recipe leaves right/left-mode width to the
   consumer) and the enter/exit slide live here. The base/utilities + `.ids-*` components
   layers come from the shared ../../../styles/tailwind-{shared,components}.css imports in
   SupportMenuSlideout.ts (ARGUS PR #164 CRITICAL). */

/* Host = popover shell only. Neutralize the UA [popover] box so it paints nothing and
   never clips the fixed surface; the discrete overlay/display transition keeps it in the
   top layer while the surface slides out on close. */
:host {
  margin: 0;
  border: 0;
  padding: 0;
  inset: auto;
  background: transparent;
  overflow: visible;
  transition:
    overlay 350ms allow-discrete,
    display 350ms allow-discrete;
}

:host(:popover-open) {
  display: block;
}

/* Surface: every visual value comes from the .ids-slideout recipe. Add only the width
   the recipe omits for right-pinned mode + the enter/exit slide. */
.support-menu-slideout-surface {
  width: clamp(320px, 30vw, 480px);
  max-width: 100vw;
  transform: translateX(100%);
  transition: transform 350ms ease-in-out;
}

:host(:popover-open) .support-menu-slideout-surface {
  transform: translateX(0);
}

@starting-style {
  :host(:popover-open) .support-menu-slideout-surface {
    transform: translateX(100%);
  }
}

@media (prefers-reduced-motion: reduce) {
  .support-menu-slideout-surface {
    transition: none;
  }
}
